import type { IMasterDataReasonCodeMappingRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataReasonCodeMappingDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataReasonCodeMappingUseCase {
  private readonly repository: IMasterDataReasonCodeMappingRepository;

  constructor(repository: IMasterDataReasonCodeMappingRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataReasonCodeMappingDTO) {
    return this.repository.updateReasonCodeMapping(params);
  }
}
